import { React, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Link from "next/link";
import LocationIcon from "../../public/images/icons/Vector.png";
import Image from "next/image";
import darkTheme  from '../../src/theme';

const clubCard = {
  borderRadius: darkTheme.spacing(1),
  paddingBottom: 0,
  textTransform: 'capitalize',
  transition: "transform 0.35s ease-in-out !important",
  boxShadow: 'none !important',
  paddingBottom: 'none',
  '& h4': {
    fontSize: `20px !important`,
    fontWeight: 500,
    color: `${darkTheme.palette.primary.title} !important`,
  },
  '& h5': {
    fontSize: 16,
    color: `${darkTheme.palette.primary.location} !important`,
    fontWeight: 400,        
  },
  '&:hover': {
    background: darkTheme.palette.background.alternate,
    transform: "scale(1.085) !important",
    zIndex: 1,
    boxShadow: darkTheme.shadows[8]
  },
  [darkTheme.breakpoints.down("md")]: {
    '& h4': {
      fontSize: `18px !important`,          
    },
    '& h5': {
      fontSize: `14px !important`,               
    },
    '&:hover': {
      transform: "none !important",
      zIndex: 1,
      boxShadow: darkTheme.shadows[8]
    },
  },
};

function ClubCard(props) {
  const [data, setData] = useState(props.data);     
  const CLUB_TITLE_MAX_LENGTH = 13;
  return (
    <Card sx={clubCard}>        
        <CardContent sx={{p:0}}>
          <Link href={'/venue/' + data.slug + '/' + data.id}>
          <a>
            {data.img_path ? (
              <Stack
                direction="row"
                spacing={{ xs: 1, sm: 1, md: 4 }}
                justifyContent="space-between"
                alignItems="flex-end"
                sx={{
                  padding: darkTheme.spacing(2),
                  background: `linear-gradient(360deg, #0c0b0f -6.68%, rgba(47, 44, 44, 0) 90.08%), 
                      url(${data.img_path}) no-repeat`,
                  width: '100%',
                  height: {md:299, sm:299, xs:249},
                  backgroundPosition: 'center center',
                  backgroundSize: 'cover',
                }}
              >
                <Typography component="div">
                  <Typography variant="h4" sx={{ mb: 0.5 }}>
                    {(data.title.length >= CLUB_TITLE_MAX_LENGTH ? data.title.substring(0, CLUB_TITLE_MAX_LENGTH) + '...' : data.title).toLowerCase()}
                  </Typography>
                  <Typography variant="h5">
                    <Image src={LocationIcon} alt="" width={12} height={16} />&nbsp;{(data.area_name)}
                  </Typography> 
                  {/* {data.clubType ? (
                      <Typography variant="p" sx={{ color: darkTheme.palette.primary.main }}>
                      {(data.clubType.length >= 20 ? data.clubType.substring(0, 20) + '...' : data.clubType).toLowerCase()}
                    </Typography>
                    ):("")} */}
                </Typography>
              </Stack>
            ) : (
                <Stack
                direction="row"
                spacing={{ xs: 1, sm: 1, md: 4 }}
                justifyContent="space-between"
                alignItems="flex-end"
                sx={{
                  padding: darkTheme.spacing(1),
                  background: `url('../../images/noImage.jpg')`,
                  width: '100%',
                  height: {md:299, sm:299, xs:249},
                  backgroundPosition: 'center',
                  backgroundSize: 'cover',
                }}
              >
                <Typography component="div">
                  <Typography variant="h4" sx={{ mb: 0.5 }}>
                    {(data.title.length >= CLUB_TITLE_MAX_LENGTH ? data.title.substring(0, CLUB_TITLE_MAX_LENGTH) + '...' : data.title).toLowerCase()}
                  </Typography>
                  <Typography variant="h5">
                    <Image src={LocationIcon} alt="" width={15} height={15} />&nbsp;{(data.area_name)}
                    </Typography>
                    {/* {data.clubType ? (
                      <Typography variant="p" sx={{ color: darkTheme.palette.primary.main }}>
                      {(data.clubType.length >= 25 ? data.clubType.substring(0, 25) + '...' : data.clubType).toLowerCase()}
                    </Typography>
                    ):("")} */}
                </Typography>
              </Stack>
            )}
            </a>
          </Link>
        </CardContent>
    </Card>
  );
}

export default ClubCard;
